import { useQuery } from '@tanstack/react-query'
import { locationApis } from '../../../gateways/breadstack/locationApis'
import { mapToLocationDetail } from '../../../types/location'
import type { LocationDetail } from '../../../types/location'

export function useLocationDetailQuery(storeId: string, warehouseId: string) {
  return useQuery<LocationDetail>({
    queryKey: ['locationDetail', storeId, warehouseId],
    queryFn: async () => {
      const raw = await locationApis.getDetail(storeId, warehouseId)
      return mapToLocationDetail(raw)
    },
    enabled: Boolean(storeId) && Boolean(warehouseId),
    staleTime: 2 * 60 * 1000,
  })
}
